import {IDialogData} from "../../../utility/components/popup/dialog.model";

export interface IFile {
  id: number
  created_by: string
  created_at: Date
  updated_at: Date | null
}

export interface IImage extends IFile {
  image_url: string,
  thumb_url: string | null
}

export interface IImageSlice {
  image_url: string,
  thumb_url: string | null
}


export function imgToSlice(img: IImage): IImageSlice {
  return {image_url: img.image_url, thumb_url: img.thumb_url}
}

export interface IFileReq {
  title: string
  description: string
  image: string | null
}


export enum FileTypes {
  IMAGE, FILE
}

export interface FileRequisition extends IDialogData {
  fileRequisitionDef: FileRequisitionDefinition
}

export interface FileRequisitionDefinition {
  pickerTitle: string
  multiSelect: boolean
  required: boolean
  existingImages: IImageSlice[]
  namespace: string
}
